import { render, staticRenderFns } from "./Censor.vue?vue&type=template&id=11738b6a&scoped=true&"
import script from "./Censor.vue?vue&type=script&lang=js&"
export * from "./Censor.vue?vue&type=script&lang=js&"
import style0 from "./Censor.vue?vue&type=style&index=0&id=11738b6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11738b6a",
  null
  
)

export default component.exports